import { createSelector } from "reselect";
import { store } from "@app/store/index";

import { StoreState } from "@app/store/store.state";
import { Fetch, State, Update } from "@app/store/reducers/data.reducer";

import { firebase } from "@app/services";

const DataState = (state: StoreState): State => state.data;
export const selectAuth = createSelector([DataState], (state) => state.auth);
export const selectStage = createSelector([DataState], (state) => state.stage);
export const selectBlocks = createSelector([DataState], (state) => state.stage?.blocks);
export const selectPlayer = createSelector([DataState], (state) => state.player);
export const selectConfig = createSelector([DataState], (state) => state.config);

var player: any = null;
export const AuthListener = async () =>
{
    firebase.auth().onAuthStateChanged((user) =>
    {
        if (!user) return;
        store.dispatch(Update({ auth: user }));

        let state = store.getState();
        if (state.data.player == null)
        {
            firebase.firestore().collection("players").doc(user.uid).onSnapshot((res) =>
            {
                let data = res.data();
                if (!data) return;

                store.dispatch(Update({ player: data }));
            });
        }
    });
};
